import { render, staticRenderFns } from "./DeleteUserButton.vue?vue&type=template&id=a1d6e690&"
import script from "./DeleteUserButton.vue?vue&type=script&lang=js&"
export * from "./DeleteUserButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports